import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay } from "swiper/modules"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { map, replace } from "lodash"
import { Link } from "gatsby"

import "swiper/css"
import "swiper/css/autoplay"
import "swiper/css/effect-coverflow"
import "../../styles/slider-products.css"

const ProductAutoSliderMini = ({ showCards }) => {
  const cards = showCards ?? false

  const data = useStaticQuery(graphql`
    query {
      allWpProduct(
        filter: {slug: {nin: ["product-crushed-garlic-mini-mes", "product-crushed-ginger-mini-mes"]}}
        sort: {products: {order: ASC}}
      ) {
        edges {
          node {
            featuredImage {
              node {
                gatsbyImage(
                  placeholder: BLURRED
                  quality: 100
                  width: 522
                  height: 395
                )
              }
            }
            title
            slug
            products {
              accentColour
              order
              productExcerpt
            }
          }
        }
      }
    }
  `)

  let products = map(data.allWpProduct.edges, ({ node }) => ({
    featuredImage: node.featuredImage?.node || "",
    accentColor: replace(node?.products?.accentColour?.[0], "_", "-") || "",
    order: node?.products?.order || "",
    excerpt: node?.products?.productExcerpt || "",
    slug: node?.slug || "",
    title: node?.title || "",
  }))

  products = products.concat(products)

  return (
    <div className="relative z-10">
      <Swiper
        freeMode={true}
        loop={true}
        allowTouchMove={false}
        autoplay={{
          delay: 0,
          pauseOnMouseEnter: true
        }}
        slidesPerView={6.5}
        speed={4000}
        modules={[Autoplay]}
        lazy={true}
        className="swipper-auto-smooth !overflow-visible"
      >
        {products.map((product, index) => {
          const img = getImage(product.featuredImage)

          // const bgAccent = `bg-${product.accentColor}`

          return (
            <SwiperSlide key={index} className=" ">
              <Link to={`/${product.slug}`}>
                <GatsbyImage
                  image={img}
                  alt={product.title}
                  className="w-full hover:scale-150 transition-all ease-in md:w-[122px] lg:w-[172px]"
                />
              </Link>
            </SwiperSlide>
          )
        })}

      </Swiper>


      <div
        className={`product-nav-prev prev hidden _md:block absolute md:top-[30%] md:!left-[30px] lg:top-[45%] lg:!-left-[15px]`}
      ></div>
      <div
        className={`product-nav-next next hidden _md:block absolute md:top-[30%] md:!right-[30px] lg:top-[45%] lg:!-right-[15px]`}
      ></div>
    </div>
  )
}

export default ProductAutoSliderMini
